/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
import anime from "animejs/lib/anime.es.js";
import React from "react";
import ReactDOM from "react-dom";
import CardOffer from "../../components/molecules/cardsOffer/cardOffer";
const buttonsHeader = document.querySelectorAll(
	".sc-offers__offers-container__header__button",
);
const buttonsMobile = document.querySelectorAll(
	".sc-offers__offers-container__button-mobile",
);

const animateCards = () => {
	const cards = document.querySelectorAll(
		".sc-offers__offers-container__swiper-container__swiper > .swiper-wrapper > .swiper-slide > .card__offer",
	);

	let options = {
		root: null,
		rootMargin: "0px",
		threshold: 0.0,
	};
	function handleCardWatcherEntry(entries, observer) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				animateCards(entry.target);
				observer.unobserve(entry.target);
			}
		});
	}

	const intersectionWathcer = () => {
		let observerCards = new IntersectionObserver(
			handleCardWatcherEntry,
			options,
		);

		cards.forEach((card) => {
			observerCards.observe(card);
		});
	};

	intersectionWathcer();

	const animateCards = (card) => {
		anime({
			targets: card,
			top: "0px",
			opacity: [0, 1],
			easing: "easeOutExpo",
			duration: 500,
			delay: 500,
		});
	};
};

buttonsHeader.forEach((button) => {
	button.addEventListener("click", () => {
		dataLayer.push({
			event: "click",
			name: button.textContent,
			page: window.location.pathname,
			id: button.textContent,
		});
	});
});

buttonsMobile.forEach((button) => {
	button.addEventListener("click", () => {
		dataLayer.push({
			event: "click",
			name: button.textContent,
			page: window.location.pathname,
			id: button.textContent,
		});
	});
});

function decodeHTMLEntities(text) {
	var textArea = document.createElement("textarea");
	textArea.innerHTML = text;
	return textArea.value;
}

let offersCount = 0;

function updateOffersArrowsVisibility() {
	const prevButtonElement = document.querySelector(
		".sc-offers__offers-container__swiper-container__prev-button",
	);
	const nextButtonElement = document.querySelector(
		".sc-offers__offers-container__swiper-container__next-button",
	);
	const isDesktop = window.innerWidth >= 767;

	if (prevButtonElement && nextButtonElement) {
		const mustShowDesktopArrows = isDesktop && offersCount > 4;
		prevButtonElement.style.display = mustShowDesktopArrows ? "flex" : "none";
		nextButtonElement.style.display = mustShowDesktopArrows ? "flex" : "none";
	}
}

function getOffers() {

	fetch(
		`${window.location.origin}/wp-json/wp/v2/categories_offer?per_page=20&hide_empty=true`,
	)
		.then((res) => res.json())
		.then((categories) => {
			fetch(
				`${window.location.origin}/wp-json/wp/v2/offer?per_page=12&_embed&orderby=date`,
			)
				.then((result) => {
					if (result.ok) {
						return result.json();
					}

					throw new Error("Something went wrong");
				})
				.then((data) => {
					offersCount = data.length;
					updateOffersArrowsVisibility();

					let toRender = data.map((offer, index) => (
						<div className="swiper-slide">
							<CardOffer
								title={decodeHTMLEntities(offer.title.rendered)}
								desc={offer.excerpt.rendered}
								termsAndConditions={offer.termsAndConditions}
								fromDate={offer.offerStartDate}
								toDate={offer.offerEndDate}
								image={offer?._embedded?.["wp:featuredmedia"]?.[0]?.source_url}
								fromTitle={"Valido desde"}
								toTitle={"Valido hasta"}
								linkHref={offer.offerLinkHref}
								linkLabel={offer.offerLinkLabel}
								index={index}
								offerCupon={offer.offerCupon}
								buttonLabel={offer.offerbuttonLabel}
								buttonLink={offer.offerbuttonLink}
								cardRedirection="disable"
							/>
						</div>
					));

					ReactDOM.render(
						toRender.slice(0, 12),
						document.querySelector(
							".sc-offers__offers-container__swiper-container__swiper > .swiper-wrapper",
						),
					);

					addListenerToOpenPopUp();
					animateCards();
				});
		});

}

const addListenerToOpenPopUp = () => {
	const links = document.querySelectorAll(".card__offer__link");

	links.forEach((link) => {
		const newLink = link.cloneNode(true);
		link.parentNode.replaceChild(newLink, link);

		newLink.addEventListener("click", () => {
			const popUp = document.getElementById(newLink.dataset.index);
			if (!popUp) return;

			const body = document.querySelector("body");
			body.appendChild(popUp);
			popUp.style.display = "flex";
			popUp.style.position = "fixed";
			popUp.style.zIndex = "99999";
			popUp.style.top = "0";
			popUp.style.left = "0";
			popUp.style.width = "100%";
			popUp.style.height = "100%";

			const overlay = popUp.children[0];
			const closeButton = popUp.children[1]?.children[0];
			const cuponValueContainer = popUp.querySelector(
				".sc-card-offer__pop-up__content__cupon__value",
			);
			const copyButton = cuponValueContainer?.querySelector("svg");

			if (overlay && !overlay.hasAttribute("data-listener-added")) {
				overlay.addEventListener("click", () => {
					popUp.style.display = "none";
				});
				overlay.setAttribute("data-listener-added", "true");
			}

			if (closeButton && !closeButton.hasAttribute("data-listener-added")) {
				closeButton.addEventListener("click", () => {
					popUp.style.display = "none";
				});
				closeButton.setAttribute("data-listener-added", "true");
			}

			if (copyButton && !copyButton.hasAttribute("data-listener-added")) {
				copyButton.style.cursor = "pointer";
				copyButton.style.transition =
					"background-color 0.2s ease, color 0.2s ease";
				
				const originalCuponText = cuponValueContainer?.textContent?.trim() || "";
				
				copyButton.addEventListener("click", (e) => {
					e.stopPropagation();
					navigator.clipboard.writeText(originalCuponText);

					const existingTooltip = cuponValueContainer?.querySelector(
						".sc-cupons-copy-tooltip",
					);

					let tooltip = existingTooltip;
					if (!tooltip && cuponValueContainer) {
						tooltip = document.createElement("span");
						tooltip.className = "sc-cupons-copy-tooltip";
						tooltip.textContent = "¡Copiado!";
						tooltip.style.cssText =
							"position:absolute; left:calc(100% + 10px); top:50%; background:#2b2b2b; color:#fff; padding:8px 12px; border-radius:8px; font-size:14px; font-weight:600; line-height:1; box-shadow:0 6px 18px rgba(0,0,0,.18); z-index:9999; opacity:0; transform:translate(6px, -50%); pointer-events:none; transition:opacity .2s ease, transform .2s ease; white-space:nowrap;";

						const tooltipArrow = document.createElement("span");
						tooltipArrow.style.cssText =
							"position:absolute; left:-6px; top:50%; transform:translateY(-50%); width:0; height:0; border-top:6px solid transparent; border-bottom:6px solid transparent; border-right:6px solid #2b2b2b;";
						tooltip.appendChild(tooltipArrow);

						const containerStyle = window.getComputedStyle(
							cuponValueContainer,
						);
						if (containerStyle.position === "static") {
							cuponValueContainer.style.position = "relative";
						}
						cuponValueContainer.appendChild(tooltip);
					}

					if (tooltip) {
						tooltip.style.opacity = "1";
						tooltip.style.transform = "translate(0, -50%)";
						window.clearTimeout(tooltip.hideTimeoutId);
						tooltip.hideTimeoutId = window.setTimeout(() => {
							tooltip.style.opacity = "0";
							tooltip.style.transform = "translate(6px, -50%)";
						}, 1200);
					}
				});

				copyButton.addEventListener("mouseenter", () => {
					copyButton.style.backgroundColor = "rgba(43, 43, 43, 0.15)";
				});

				copyButton.addEventListener("mouseleave", () => {
					copyButton.style.backgroundColor = "transparent";
					copyButton.style.color = "inherit";
				});
				copyButton.setAttribute("data-listener-added", "true");
			}
		});
	});
};


document.addEventListener("DOMContentLoaded", function () {


	const swiperContainerOffers = document.querySelector(
		".sc-offers__offers-container__swiper-container",
	);
	const swiperWrappercontainer = document.querySelector(
		".sc-offers__offers-container__swiper-container__swiper",
	);

	let animationDuration = swiperContainerOffers ? parseInt(swiperContainerOffers.dataset.duration) : 5000;
	const swiperOffers = new Swiper(
		".sc-offers__offers-container__swiper-container__swiper",
		{
			slidesPerView: 1.3,
			spaceBetween: 16,
			spaceBetweenMobile: 5,
			rewind: true,
			speed: 500,
			autoplay:{
				delay: animationDuration,
				disableOnInteraction: false,

			},
			breakpoints: {
				480: {
					slidesPerView: 1.3,
					spaceBetween: 32,
				},
				576: {
					slidesPerView: 2,
					spaceBetween: 32,
				},
				767: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
			},
			navigation: {
				nextEl: ".sc-offers__offers-container__swiper-container__next-button",
				prevEl: ".sc-offers__offers-container__swiper-container__prev-button",
			},
		},
	);

	getOffers();
	window.addEventListener("resize", updateOffersArrowsVisibility);
})

/* eslint-enable no-console */
